import { CardIcon } from '../components/icons'

/**
 * Billing. Pricing is intentionally DEFERRED — no prices, catalogs or
 * checkout exist yet. Stripe integration is the last Phase-2 work item.
 */
export function BillingPage() {
  return (
    <div className="flex flex-col gap-8">
      <header className="flex flex-col gap-3">
        <h1 className="font-display text-display-l text-ink">Billing</h1>
        <p className="max-w-prose text-body-l text-ink-muted">
          Plans, invoices and payment history for your organization.
        </p>
      </header>

      <div className="flex flex-col items-center gap-5 rounded-2xl border border-line bg-ground-2 px-8 py-20 text-center">
        <span className="text-cobalt">
          <CardIcon width={32} height={32} />
        </span>
        <h2 className="font-display text-display-m text-ink">Pricing coming soon</h2>
        <p className="max-w-prose text-body text-ink-muted">
          We're finalizing our plans for SaaS subscriptions, templates, UIMatrix licenses and service
          engagements. When billing opens, this page will show your subscription, upcoming charges
          and downloadable invoices.
        </p>
        <p className="text-small text-ink-faint">
          Questions in the meantime? Reach out to your nMach contact.
        </p>
      </div>
    </div>
  )
}
